import { helpers } from '../../common/lib';
import getInitialState from '../get-initial-state';
import { actionTypes } from './actions';

const initialState = { ...getInitialState.list() };

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.USER_ORGANISATION_ITEM_CLEAR: {
      return { ...state, item: null };
    }
    case actionTypes.USER_ORGANISATION_ITEM_SET: {
      const { userOrganisation } = action.payload;
      return { ...state, item: userOrganisation };
    }
    case actionTypes.USER_ORGANISATIONS_CLEAR: {
      return { ...initialState };
    }
    case actionTypes.USER_ORGANISATIONS_GET_SUCCESS: {
      const { userOrganisations } = action.payload;
      return helpers.getListReducer(state, userOrganisations);
    }
    default: {
      return state;
    }
  }
}
